/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <span class="loading-btn">
    <span
      v-if="percent<100"
      class="loading-btn-progress"
      :style="{ width: percent + '%' }"
    />
    <button
      :type="type"
      :disabled="loading || disabled"
      class="btn btn-primary"
    >
      <slot>Submit</slot>
      <svg
        v-if="loading"
        class="icon-refresh rotate"
        style="width: 12px; height: 12px;"
      >
        <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
      </svg>
    </button>
  </span>
</template>

<style lang="less">
  @import '~bootstrap/less/variables';
  @import '../../less/bootstrap-vars';

  .loading-btn {
    position: relative;
    display: inline-block;

    svg {
      fill: white;
    }

    .loading-btn-progress {
      display:block;
      position: absolute;
      width: 0;
      height: 100%;
      border-radius: @btn-border-radius-base;
    }
  }
</style>

<script>
export default {
  props: {
    type: { default: 'submit' },
    loading: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    progress: {}
  },
  computed: {
    percent() {
      return 100*Math.min(this.progress, 1);
    }
  }
};
</script>
